import { takeEvery, put, call, all, fork } from "redux-saga/effects";

import {
  GET_JOBS_DATA,
  ADD_NEW_JOB,
  DELETE_JOB,
  UPDATE_JOB,
  GET_JOB_STATUS_DATA,
  ADD_NEW_JOB_STATUS,
  DELETE_JOB_STATUS,
  UPDATE_JOB_STATUS,
  GET_JOBS_PDF_DATA,
  GET_JOBS_TYPE_DATA,
  GET_JOBS_PRIORITY_DATA,
  GET_SINGLE_CUSTOMER_JOBS_LIST_DATA,
  GET_UNINVOICED_JOBS_LIST_DATA,
  CONVERT_JOB_TO_INVOICE,
  GET_RECURRING_JOBS_LIST_DATA,
  CREATE_RECURRING_JOB,
  GET_RECURRING_JOB_DETAILS,
  UPDATE_RECURRING_JOB,
  UPLOAD_JOB_FILES,
  SEARCH_SINGLE_JOB_FILES_LIST,
  ADD_JOB_TYPE,
  DELETE_JOB_TYPE,
  UPDATE_JOB_TYPE,
  ADD_JOB_PRIORITY,
  DELETE_JOB_PRIORITY,
  UPDATE_JOB_PRIORITY,
  DELETE_SINGLE_JOB_FILE,
  UPDATE_FILE_ATTACHMENT,
  GET_JOB_SEARCH_LIST_DATA,
  GET_JOBS_OPEN_LIST_DATA,
  GET_READY_TO_INVOICE_JOBS_LIST_DATA,
  MARK_JOB_AS_COMPLETED,
  CONVERT_JOB_TO_PROFORMA_INVOICE,
  GET_INVOICES_BY_JOB,
  PREDICTED_MARK_BILLED,
  PREDICTED_LINK_TO_INVOICEITEM,
} from "./actionTypes";

import {
  getJobsDataSuccess,
  getJobsDataFail,
  addJobSuccess,
  addJobFail,
  deleteJobSuccess,
  deleteJobFail,
  updateJobSuccess,
  updateJobFail,
  getJobStatusDataSuccess,
  getJobStatusDataFail,
  addJobStatusSuccess,
  addJobStatusFail,
  deleteJobStatusSuccess,
  deleteJobStatusFail,
  updateJobStatusSuccess,
  updateJobStatusFail,
  getJobsPDFDataSuccess,
  getJobsPDFDataFail,
  getJobsTypeDataSuccess,
  getJobsTypeDataFail,
  getJobsPriorityDataSuccess,
  getJobsPriorityDataFail,
  getSingleCustomerJobsListSuccess,
  getSingleCustomerJobsListFail,
  getUninvoicedJobsListSuccess,
  getUninvoicedJobsListFail,
  convertJobToInvoiceSuccess,
  convertJobToInvoiceFail,
  getRecurringJobsListSuccess,
  getRecurringJobsListFail,
  createRecurringJobSuccess,
  createRecurringJobFail,
  getRecurringJobDetailSuccess,
  getRecurringJobDetailFail,
  updateRecurringJobSuccess,
  updateRecurringJobFail,
  uploadJobFilesSuccess,
  uploadJobFilesFail,
  searchSingleJobFilesListSuccess,
  searchSingleJobFilesListFail,
  addJobTypeSuccess,
  addJobTypeFail,
  deleteJobTypeSuccess,
  deleteJobTypeFail,
  updateJobTypeSuccess,
  updateJobTypeFail,
  addJobPrioritySuccess,
  addJobPriorityFail,
  deleteJobPrioritySuccess,
  deleteJobPriorityFail,
  updateJobPrioritySuccess,
  updateJobPriorityFail,
  deleteSingleJobFileSuccess,
  deleteSingleJobFileFail,
  updateFileAttachmentSuccess,
  updateFileAttachmentFail,
  getJobSearchListSuccess,
  getJobSearchListFail,
  getJobsOpenListSuccess,
  getJobsOpenListFail,
  getReadyToInvoiceJobsListSuccess,
  getReadyToInvoiceJobsListFail,
  markJobAsCompletedSuccess,
  markJobAsCompletedFail,
  convertJobToProformaInvoiceSuccess,
  convertJobToProformaInvoiceFail,
  getInvoicesByJobSuccess,
  getInvoicesByJobFail,
  predictedMarkBilledSuccess,
  predictedMarkBilledFail,
  predictedLinkToInvoiceItemSuccess,
  predictedLinkToInvoiceItemFail,
} from "./actions";

import {
  getJobsList,
  addNewJob,
  deleteJob,
  updateJob,
  getJobsStatusList,
  addNewJobStatus,
  deleteJobStatus,
  updateJobStatus,
  getPDFJobSheetSinglePageData,
  getJobTypeList,
  getJobPriorityList,
  getSingleCustomerJobsListDataApiCall,
  getUninvoicedJobsListApiCall,
  convertJobToInvoiceApiCall,
  getRecurringJobsListApiCall,
  createRecurringJobApiCall,
  getRecurringJobDetailApiCall,
  updateRecurringJobApiCall,
  uploadJobFilesApiCall,
  searchSingleJobFilesListApiCall,
  addJobTypeApiCall,
  deleteJobTypeApiCall,
  updateJobTypeApiCall,
  addJobPriorityApiCall,
  deleteJobPriorityApiCall,
  updateJobPriorityApiCall,
  deleteSingleJobFileApiCall,
  updateFileAttachmentApiCall,
  getJobSearchListApiCall,
  getJobsOpenListApiCall,
  getReadyToInvoiceJobsListApiCall,
  markJobAsCompletedApiCall,
  convertJobToProformaInvoiceApiCall,
  invoicesByJobApiCall,
  predictedMarkBilledApiCall,
  predictedLinkToInvoiceItemApiCall,
} from "../../helpers/fakebackend_helper";

//*****************************  Jobs List CRUD Saga  *********************************//

// add new job "Create"
function* onAddNewJob({ payload: newJob }) {
  try {
    const response = yield call(addNewJob, newJob);
    yield put(addJobSuccess(response));
  } catch (error) {
    yield put(addJobFail(error));
  }
}

export function* watchAddNewJob() {
  yield takeEvery(ADD_NEW_JOB, onAddNewJob);
}
// get jobs data "Read"

function* fetchJobsData() {
  try {
    const response = yield call(getJobsList);
    yield put(getJobsDataSuccess(response));
  } catch (error) {
    yield put(getJobsDataFail(error));
  }
}

export function* watchFetchJobsData() {
  yield takeEvery(GET_JOBS_DATA, fetchJobsData);
}

// update job "Update"
function* onUpdateJob({ payload: Job }) {
  try {
    const response = yield call(updateJob, Job);
    yield put(updateJobSuccess(response));
  } catch (error) {
    yield put(updateJobFail(error));
  }
}

export function* watchUpdateJob() {
  yield takeEvery(UPDATE_JOB, onUpdateJob);
}

// delete job "Delete"
function* onDeleteJob({ payload: Job }) {
  try {
    const response = yield call(deleteJob, Job);
    yield put(deleteJobSuccess(response));
  } catch (error) {
    yield put(deleteJobFail(error));
  }
}

export function* watchDeleteJob() {
  yield takeEvery(DELETE_JOB, onDeleteJob);
}
//*****************************  Jobs Status CRUD Saga  *********************************//

// add New Job Status "Create"

function* onAddNewJobStatus({ payload: newJobStatus }) {
  try {
    const response = yield call(addNewJobStatus, newJobStatus);
    yield put(addJobStatusSuccess(response));
  } catch (error) {
    yield put(addJobStatusFail(error));
  }
}

export function* watchAddNewJobStatus() {
  yield takeEvery(ADD_NEW_JOB_STATUS, onAddNewJobStatus);
}
// get jobs status data "Read"

function* fetchJobsStatusData() {
  try {
    const response = yield call(getJobsStatusList);
    yield put(getJobStatusDataSuccess(response));
  } catch (error) {
    yield put(getJobStatusDataFail(error));
  }
}

export function* watchFetchJobsStatusData() {
  yield takeEvery(GET_JOB_STATUS_DATA, fetchJobsStatusData);
}

// Update Job Status "Update"

function* onUpdateJobStatus({ payload: JobStatus }) {
  try {
    const response = yield call(updateJobStatus, JobStatus);
    yield put(updateJobStatusSuccess(response));
  } catch (error) {
    yield put(updateJobStatusFail(error));
  }
}

export function* watchUpdateJobStatus() {
  yield takeEvery(UPDATE_JOB_STATUS, onUpdateJobStatus);
}

// Delete Job Status "Delete"

function* onDeleteJobStatus({ payload: JobStatus }) {
  try {
    const response = yield call(deleteJobStatus, JobStatus);
    yield put(deleteJobStatusSuccess(response));
  } catch (error) {
    yield put(deleteJobStatusFail(error));
  }
}

export function* watchDeleteJobStatus() {
  yield takeEvery(DELETE_JOB_STATUS, onDeleteJobStatus);
}

// get jobs pdf data "Read"

function* fetchJobsPDFData({ payload }) {
  try {
    const job = yield call(getPDFJobSheetSinglePageData, payload);
    yield put(getJobsPDFDataSuccess(job));
  } catch (error) {
    yield put(getJobsPDFDataFail(error));
  }
}

export function* watchFetchJobsPDFData() {
  yield takeEvery(GET_JOBS_PDF_DATA, fetchJobsPDFData);
}

// get jobs type data "Read"

function* fetchJobsTypeData() {
  try {
    const response = yield call(getJobTypeList);
    yield put(getJobsTypeDataSuccess(response));
  } catch (error) {
    yield put(getJobsTypeDataFail(error));
  }
}

export function* watchFetchJobsTypeData() {
  yield takeEvery(GET_JOBS_TYPE_DATA, fetchJobsTypeData);
}

// get jobs priority data "Read"

function* fetchJobsPriorityData() {
  try {
    const response = yield call(getJobPriorityList);
    yield put(getJobsPriorityDataSuccess(response));
  } catch (error) {
    yield put(getJobsPriorityDataFail(error));
  }
}

export function* watchFetchJobsPriorityData() {
  yield takeEvery(GET_JOBS_PRIORITY_DATA, fetchJobsPriorityData);
}

//***************************** Single Customer Jobs List Data CRUD Saga  *********************************//

// single customer jobs list data "Search"

function* fetchSingleCustomerJobsListData({ payload }) {
  try {
    const response = yield call(getSingleCustomerJobsListDataApiCall, payload);
    yield put(getSingleCustomerJobsListSuccess(response));
  } catch (error) {
    yield put(getSingleCustomerJobsListFail(error));
  }
}

export function* watchFetchSingleCustomerJobsListData() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_JOBS_LIST_DATA,
    fetchSingleCustomerJobsListData
  );
}

// Get Univoiced Jobs List APi Call

function* fetchUninvoicedJobsListData({ payload }) {
  try {
    const response = yield call(getUninvoicedJobsListApiCall, payload);
    yield put(getUninvoicedJobsListSuccess(response));
  } catch (error) {
    yield put(getUninvoicedJobsListFail(error));
  }
}

export function* watchFetchUninvoicedJobsListData() {
  yield takeEvery(GET_UNINVOICED_JOBS_LIST_DATA, fetchUninvoicedJobsListData);
}

// Convert Jobs to Invoice APi Call

function* convertJobsToInvoice({ payload }) {
  try {
    const response = yield call(convertJobToInvoiceApiCall, payload);
    yield put(convertJobToInvoiceSuccess(response));
  } catch (error) {
    yield put(convertJobToInvoiceFail(error));
  }
}

export function* watchConvertJobsToInvoice() {
  yield takeEvery(CONVERT_JOB_TO_INVOICE, convertJobsToInvoice);
}

// Get Recurring Jobs List APi Call

function* fetchRecurringJobsListData() {
  try {
    const response = yield call(getRecurringJobsListApiCall);
    yield put(getRecurringJobsListSuccess(response));
  } catch (error) {
    yield put(getRecurringJobsListFail(error));
  }
}

export function* watchFetchRecurringJobsListData() {
  yield takeEvery(GET_RECURRING_JOBS_LIST_DATA, fetchRecurringJobsListData);
}

// Create recurring Job

function* createRecurringJob({ payload }) {
  try {
    const response = yield call(createRecurringJobApiCall, payload);
    yield put(createRecurringJobSuccess(response));
  } catch (error) {
    yield put(createRecurringJobFail(error));
  }
}

export function* watchCreateRecurringJob() {
  yield takeEvery(CREATE_RECURRING_JOB, createRecurringJob);
}

// Get Recurring Job Details APi Call

function* getRecurringJobDetails({ payload }) {
  try {
    const response = yield call(getRecurringJobDetailApiCall, payload);
    yield put(getRecurringJobDetailSuccess(response));
  } catch (error) {
    yield put(getRecurringJobDetailFail(error));
  }
}

export function* watchGetRecurringJobDetails() {
  yield takeEvery(GET_RECURRING_JOB_DETAILS, getRecurringJobDetails);
}

// Update Recurring Job

function* updateRecurringJob({ payload }) {
  try {
    const response = yield call(updateRecurringJobApiCall, payload);
    yield put(updateRecurringJobSuccess(response));
  } catch (error) {
    yield put(updateRecurringJobFail(error));
  }
}

export function* watchUpdateRecurringJob() {
  yield takeEvery(UPDATE_RECURRING_JOB, updateRecurringJob);
}
// Upload JobFiles and assign to Multiple Jobs

function* uploadJobFiles({ payload }) {
  try {
    const response = yield call(uploadJobFilesApiCall, payload);
    yield put(uploadJobFilesSuccess(response));
  } catch (error) {
    yield put(uploadJobFilesFail(error));
  }
}

export function* watchUploadJobFiles() {
  yield takeEvery(UPLOAD_JOB_FILES, uploadJobFiles);
}

// Search Single Job Files List

function* searchSingleJobFilesList({ payload }) {
  try {
    const response = yield call(searchSingleJobFilesListApiCall, payload);
    yield put(searchSingleJobFilesListSuccess(response));
  } catch (error) {
    yield put(searchSingleJobFilesListFail(error));
  }
}

export function* watchSearchSingleJobFilesList() {
  yield takeEvery(SEARCH_SINGLE_JOB_FILES_LIST, searchSingleJobFilesList);
}

// Add Job Type

function* addJobType({ payload }) {
  try {
    const response = yield call(addJobTypeApiCall, payload);
    yield put(addJobTypeSuccess(response));
  } catch (error) {
    yield put(addJobTypeFail(error));
  }
}

export function* watchAddJobType() {
  yield takeEvery(ADD_JOB_TYPE, addJobType);
}

// Update Job Type

function* updateJobType({ payload }) {
  try {
    const response = yield call(updateJobTypeApiCall, payload);
    yield put(updateJobTypeSuccess(response));
  } catch (error) {
    yield put(updateJobTypeFail(error));
  }
}

export function* watchUpdateJobType() {
  yield takeEvery(UPDATE_JOB_TYPE, updateJobType);
}

// Delete Job Type

function* deleteJobType({ payload }) {
  try {
    const response = yield call(deleteJobTypeApiCall, payload);
    yield put(deleteJobTypeSuccess(response));
  } catch (error) {
    yield put(deleteJobTypeFail(error));
  }
}

export function* watchDeleteJobType() {
  yield takeEvery(DELETE_JOB_TYPE, deleteJobType);
}

// Add Job Priority

function* addJobPriority({ payload }) {
  try {
    const response = yield call(addJobPriorityApiCall, payload);
    yield put(addJobPrioritySuccess(response));
  } catch (error) {
    yield put(addJobPriorityFail(error));
  }
}

export function* watchAddJobPriority() {
  yield takeEvery(ADD_JOB_PRIORITY, addJobPriority);
}

// Update Job Priority

function* updateJobPriority({ payload }) {
  try {
    const response = yield call(updateJobPriorityApiCall, payload);
    yield put(updateJobPrioritySuccess(response));
  } catch (error) {
    yield put(updateJobPriorityFail(error));
  }
}

export function* watchUpdateJobPriority() {
  yield takeEvery(UPDATE_JOB_PRIORITY, updateJobPriority);
}

// Delete Job Priority

function* deleteJobPriority({ payload }) {
  try {
    const response = yield call(deleteJobPriorityApiCall, payload);
    yield put(deleteJobPrioritySuccess(response));
  } catch (error) {
    yield put(deleteJobPriorityFail(error));
  }
}

export function* watchDeleteJobPriority() {
  yield takeEvery(DELETE_JOB_PRIORITY, deleteJobPriority);
}

// Delete Single Job File

function* deleteSingleJobFile({ payload }) {
  try {
    const response = yield call(deleteSingleJobFileApiCall, payload);
    yield put(deleteSingleJobFileSuccess(response));
  } catch (error) {
    yield put(deleteSingleJobFileFail(error));
  }
}

export function* watchDeleteSingleJobFile() {
  yield takeEvery(DELETE_SINGLE_JOB_FILE, deleteSingleJobFile);
}

// Update File Attachment

function* updateFileAttachment({ payload }) {
  try {
    const response = yield call(updateFileAttachmentApiCall, payload);
    yield put(updateFileAttachmentSuccess(response));
  } catch (error) {
    yield put(updateFileAttachmentFail(error));
  }
}

export function* watchUpdateFileAttachment() {
  yield takeEvery(UPDATE_FILE_ATTACHMENT, updateFileAttachment);
}
//GET_JOB_SEARCH_LIST_DATA
function* fetchJobSearchListData({ payload }) {
  try {
    const response = yield call(getJobSearchListApiCall, payload);
    yield put(getJobSearchListSuccess(response));
  } catch (error) {
    yield put(getJobSearchListFail(error));
  }
}

export function* watchFetchJobSearchListData() {
  yield takeEvery(GET_JOB_SEARCH_LIST_DATA, fetchJobSearchListData);
}

//GET_JOBS_OPEN_LIST_DATA
function* fetchJobsOpenListData() {
  try {
    const response = yield call(getJobsOpenListApiCall);
    yield put(getJobsOpenListSuccess(response));
  } catch (error) {
    yield put(getJobsOpenListFail(error));
  }
}

export function* watchFetchJobsOpenListData() {
  yield takeEvery(GET_JOBS_OPEN_LIST_DATA, fetchJobsOpenListData);
}

//GET_READY_TO_INVOICE_JOBS_LIST_DATA
function* fetchReadyToInvoiceJobsListData() {
  try {
    const response = yield call(getReadyToInvoiceJobsListApiCall);
    yield put(getReadyToInvoiceJobsListSuccess(response));
  } catch (error) {
    yield put(getReadyToInvoiceJobsListFail(error));
  }
}

export function* watchFetchReadyToInvoiceJobsListData() {
  yield takeEvery(
    GET_READY_TO_INVOICE_JOBS_LIST_DATA,
    fetchReadyToInvoiceJobsListData
  );
}

//MARK_JOB_AS_COMPLETED
function* markJobAsCompleted({ payload }) {
  try {
    const response = yield call(markJobAsCompletedApiCall, payload);
    yield put(markJobAsCompletedSuccess(response));
  } catch (error) {
    yield put(markJobAsCompletedFail(error));
  }
}

export function* watchMarkJobAsCompleted() {
  yield takeEvery(MARK_JOB_AS_COMPLETED, markJobAsCompleted);
}

//CONVERT_JOB_TO_PROFORMA_INVOICE
function* convertJobToProformaInvoice({ payload }) {
  try {
    const response = yield call(convertJobToProformaInvoiceApiCall, payload);
    yield put(convertJobToProformaInvoiceSuccess(response));
  } catch (error) {
    yield put(convertJobToProformaInvoiceFail(error));
  }
}

export function* watchConvertJobToProformaInvoice() {
  yield takeEvery(CONVERT_JOB_TO_PROFORMA_INVOICE, convertJobToProformaInvoice);
}

//GET_INVOICES_BY_JOB
function* getInvoicesByJob({ payload }) {
  try {
    const response = yield call(invoicesByJobApiCall, payload);
    yield put(getInvoicesByJobSuccess(response));
  } catch (error) {
    yield put(getInvoicesByJobFail(error));
  }
}

export function* watchGetInvoicesByJob() {
  yield takeEvery(GET_INVOICES_BY_JOB, getInvoicesByJob);
}

// PREDICTED_MARK_BILLED — mark / unmark a predicted line as manually billed
function* predictedMarkBilled({ payload }) {
  try {
    const response = yield call(predictedMarkBilledApiCall, payload);
    yield put(predictedMarkBilledSuccess(response));
  } catch (error) {
    yield put(predictedMarkBilledFail(error));
  }
}

export function* watchPredictedMarkBilled() {
  yield takeEvery(PREDICTED_MARK_BILLED, predictedMarkBilled);
}

// PREDICTED_LINK_TO_INVOICEITEM — link a predicted line to an invoice line item
function* predictedLinkToInvoiceItem({ payload }) {
  try {
    const response = yield call(predictedLinkToInvoiceItemApiCall, payload);
    yield put(predictedLinkToInvoiceItemSuccess(response));
  } catch (error) {
    yield put(predictedLinkToInvoiceItemFail(error));
  }
}

export function* watchPredictedLinkToInvoiceItem() {
  yield takeEvery(PREDICTED_LINK_TO_INVOICEITEM, predictedLinkToInvoiceItem);
}

// main saga function
function* jobsSaga() {
  yield all([
    fork(watchFetchJobsData),
    fork(watchAddNewJob),
    fork(watchDeleteJob),
    fork(watchUpdateJob),
    fork(watchFetchJobsStatusData),
    fork(watchAddNewJobStatus),
    fork(watchDeleteJobStatus),
    fork(watchUpdateJobStatus),
    fork(watchFetchJobsPDFData),
    fork(watchFetchJobsTypeData),
    fork(watchFetchJobsPriorityData),
    fork(watchFetchSingleCustomerJobsListData),
    fork(watchFetchUninvoicedJobsListData),
    fork(watchConvertJobsToInvoice),
    fork(watchFetchRecurringJobsListData),
    fork(watchCreateRecurringJob),
    fork(watchGetRecurringJobDetails),
    fork(watchUpdateRecurringJob),
    fork(watchUploadJobFiles),
    fork(watchSearchSingleJobFilesList),
    fork(watchAddJobType),
    fork(watchUpdateJobType),
    fork(watchDeleteJobType),
    fork(watchAddJobPriority),
    fork(watchUpdateJobPriority),
    fork(watchDeleteJobPriority),
    fork(watchDeleteSingleJobFile),
    fork(watchUpdateFileAttachment),
    fork(watchFetchJobSearchListData),
    fork(watchFetchJobsOpenListData),
    fork(watchFetchReadyToInvoiceJobsListData),
    fork(watchMarkJobAsCompleted),
    fork(watchConvertJobToProformaInvoice),
    fork(watchGetInvoicesByJob),
    fork(watchPredictedMarkBilled),
    fork(watchPredictedLinkToInvoiceItem),
  ]);
}

export default jobsSaga;
